import type { UsDiscoveryMarket } from './marketClient';
import { usGamePropFamily, validUsGamePropLine } from './gamePropFamily';
export interface UsGamePropTarget {
  marketSlug: string; marketId: string; sportsMarketType: string; line: string;
}
export function usGamePropTarget(m: UsDiscoveryMarket): UsGamePropTarget | null {
  if (!usGamePropFamily(m.sportsMarketType, m.sport) || m.marketType !== 'props' || m.period !== 'full'
    || m.yesTeam !== null || m.playerProp != null || !validUsGamePropLine(m.sportsMarketType, m.sport, m.line)
    || !/^[A-Za-z0-9_-]{1,256}$/.test(m.marketSlug) || !/^[0-9]{1,32}$/.test(m.marketId)) return null;
  return { marketSlug: m.marketSlug, marketId: m.marketId, sportsMarketType: m.sportsMarketType, line: m.line! };
}
export function sameUsGamePropTarget(a: UsGamePropTarget, b: UsGamePropTarget): boolean {
  return a.marketSlug === b.marketSlug && a.marketId === b.marketId && a.sportsMarketType === b.sportsMarketType && a.line === b.line;
}
